const isEmptyObj = (obj: Record<string, any> | undefined): boolean => Object.keys(obj ?? {}).length === 0;

export default isEmptyObj;
